export default __webpack_public_path__ + "e9879fe0d29c9568d3d2bf3783d3cc9f.png";